<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">Registro de Pago</span></h3>
          </v-card-title>
                    <v-card-text>
                        <!-- <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm4>
                                    <v-text-field
                                        ref="rif"
                                        v-model="form.rif"
                                        prepend-icon="featured_video"
                                        label="RIF"
                                        :rules="[v => !!v || 'RIF es requerido']"
                                        required
                                        mask="A-########-#"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm8>
                                    <v-text-field
                                        ref="razonsocial"
                                        v-model="form.razon_social"
                                        prepend-icon="person"
                                        label="Razon social"
                                        :rules="[v => !!v || 'Razon social es requerido']"
                                        required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex> -->
                        <!-- <v-flex xs12>
                            <v-text-field
                                ref="direccionfiscal"
                                v-model="form.direccion_fiscal"
                                prepend-icon="domain"
                                label="Direccion Fiscal"
                                :rules="[v => !!v || 'Direccion Fiscal es requerido']"
                                required
                            ></v-text-field>
                        </v-flex> -->
                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm6>
                                    <v-select
                                        prepend-icon="account_balance_wallet"
                                        :items="wayToPay"
                                        v-model="form.way_to_pay"
                                        @change="changeWayToPay"
                                        label="Método de pago"
                                        :rules="[v => !!v || 'Método de pago es requerido']"
                                        required
                                    ></v-select>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light" aria-required="true" aria-invalid="false">
                                        <div class="v-input__prepend-outer">
                                            <div class="v-input__icon v-input__icon--prepend">
                                                <i aria-hidden="true" class="v-icon material-icons theme--light">credit_card</i>
                                            </div>
                                        </div>
                                        <div class="v-input__control">
                                            <div class="v-input__slot">
                                                <div class="v-text-field__slot">
                                                    <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Monto a pagar</label>
                                                    <vue-numeric currency="BsS" v-model="form.amount" v-bind:precision="2" v-bind:min="0" decimal-separator="," thousand-separator="."></vue-numeric>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                prepend-icon="account_balance"
                                :items="banks"
                                v-model="form.bank_id"
                                item-text="name"
                                item-value="id"
                                label="Banco"
                                :rules="[v => !!v || 'Banco de pago es requerido']"
                                required
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 align-center justify-space-between>
                            <v-layout align-center>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                        v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                        ref="number"
                                        v-model="form.number"
                                        prepend-icon="remove"
                                        label="Número de transacción"
                                        mask="###############"
                                        :rules="[v => !!v || 'Número de transacción es requerido']"
                                        required
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-menu
                                        ref="menu"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="menu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        min-width="290px"
                                        :return-value.sync="date"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            label="Fecha"
                                            v-model="computedDateFormattedFecha"
                                            hint="DD/MM/YYYY formato"
                                            prepend-icon="event"
                                            :rules="[v => !!v || 'Fecha es requerido']"
                                            required
                                            readonly
                                        ></v-text-field>
                                        <v-date-picker color="primary" :max="new Date().toISOString().slice(0,10)" v-model="form.payment_date" no-title scrollable>
                                        <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                            <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-textarea
                                prepend-icon="reorder"
                                v-model="form.observations"
                                auto-grow
                                color="primary"
                                label="Observación"
                                rows="2"
                                :rules="[v => !!v || 'La Observación es Requerida']"
                            ></v-textarea>
                        </v-flex>
                        <v-flex xs12>
                            <input hidden type="file" ref="fileInput" @change="processFile($event)">
                            <v-text-field
                                ref="document"
                                v-model="nameImg"
                                @click.native="onFocus"
                                prepend-icon="attach_file"
                                label="Comprobante de pago"
                            ></v-text-field>
                        </v-flex>
                </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="loading" class="primary" @click="registrarPago">Registrar Pago</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import VueNumeric from 'vue-numeric'

Number.prototype.toFixedDown = function (digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {
    
    name: 'form-registro-pago-view',

    props: {
        loading: {
            type: Boolean,
            required: true
        },
        datos: {
            type: Object,
            required: true
        }
    },

    components: {
        VueNumeric
    },

    watch: {
        datos(v) {
            console.log(v,'datos')
            this.$refs.form.resetValidation()
            this.nameImg = ''
            this.form = {
                invoice_id: v.id,
                unionize_id: v.unionize_id,
                bank_id: '',
                way_to_pay: 'TRANSFERENCIA',
                amount: parseFloat(v.amount).toFixedDown(2),
                number: null,
                payment_date: '',
                observations: '',
                file: '',
            }
        }
    },
      
    computed: {
        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date)
        }
    },

  data: () => ({
    valid: false,
    date: null,
    fecha: null,
    menu: false,
    nameImg: '',
    wayToPay: ['TRANSFERENCIA'],
    banks: [],
    form: new Form({
        invoice_id: '',
        unionize_id: '',
        bank_id: '',
        way_to_pay: 'TRANSFERENCIA',
        amount: 0,
        number: null,
        payment_date: '',
        observations: '',
        file: '',
    })
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
    this.getBanks()
  },

  methods: {

    async getBanks(){
        await axios.get(`/api/pay/admin/getAllBanks`)
            .then(res => {
                this.banks = res.data.bancos
            })
    },


    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },

    async changeWayToPay() {
        if(this.form.way_to_pay == 'EFECTIVO - MONEDA LOCAL'){
            this.form.number = null
        }
        if(this.form.way_to_pay == 'EFECTIVO - DIVISAS'){
            this.form.number = null
        }
    },

    onFocus() {
        this.$refs.fileInput.value = ''
        this.$refs.fileInput.click()
    },

    processFile(event) {
        let files = event.target.files || event.dataTransfer.files
        if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg" || files[0].type == "application/pdf") {
            this.form.file = files[0]
            this.nameImg = files[0].name
        }else {
            this.$store.dispatch('responseMessage', {
                type: 'error',
                text: 'El formato del documento debe ser PNG/JPG/JPEG o PDF'
            })
        }
    },
    
    async registrarPago () {
        if (this.$refs.form.validate()) {
            if(this.form.amount == 0){
                this.$store.dispatch('responseMessage', {
                    type: 'info',
                    text: `Ingrese el monto a registrar`
                })
            }else {
                this.$emit('responseLoading', true)
                let formData = new FormData();
                for (var key in this.form) {
                    formData.append(key, this.form[key]);
                }
                let url = '/api/administration/cobranza/registrar-pago'
                await axios.post(url, formData).then(resp => {
                    this.cerrarDialog(resp)
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: `Pago Registrado`
                    })
                }).catch(e => {
                    console.log(e.response)
                    if (e.response.data.errors) {
                        if (e.response.data.errors.file) {
                            this.$store.dispatch('responseMessage', {
                                type: 'error',
                                text: e.response.data.errors.file
                            })
                        }else if (e.response.data.errors.pago) {
                            this.$store.dispatch('responseMessage', {
                                type: 'error',
                                text: e.response.data.errors.pago
                            })
                        } else if (e.response.data.errors.security_paper) {
                            this.$store.dispatch('responseMessage', {
                                type: 'error',
                                text: e.response.data.errors.security_paper
                            })
                        } else {
                            this.$store.dispatch('responseMessage', {
                                type: 'error',
                                text: e.response.data.error
                            })
                        }
                    }
                }).finally(() => this.$emit('responseLoading', false))
            }
        }
    },

    cerrarDialog (data) {
        this.$emit('closeDialogRegistrarPago', data)
        this.$nextTick(() => {
            this.$refs.form.resetValidation()
            this.$emit('responseLoading', false)
        })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/FormRegistroPago.vue